import {
  Button,
  Card,
  DescriptionList,
  Heading,
  Layout,
  Spinner,
} from "@vwfs-bronson/bronson-react";
import { StepsWizard } from "../components/common/StepsWizard";
import { useTranslation } from "react-i18next";
import { usePayments } from "../hooks/usePayments";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackOnOverviewPage } from "../adobeTracking/trackers";
import { useNotification } from "../hooks/useNotification";
import { usePathname } from "../hooks/usePathname";
import { Pathname } from "../enums";

export const OverviewPage = () => {
  const { t } = useTranslation("overviewpage");
  const navigate = useNavigate();
  const { handleDeleteAllNotifications } = useNotification();
  const { pathname } = usePathname();
  const {
    handleGetOverViewDetails,
    OverViewDetails,
    handleCreatePayment,
    loadingPayment,
  } = usePayments();

  useEffect(() => {
    handleGetOverViewDetails();
    trackOnOverviewPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout center>
      <StepsWizard activeStep={3} />
      <Layout.Item></Layout.Item>
      <Layout.Item
        default="3/6"
        xs="1/1"
        l="1/1"
        m="1/1"
        s="1/1"
        className="u-text-left"
      >
        {OverViewDetails && (
          <>
            <Heading className="u-text-center" level={1}>
              {t("header")}
            </Heading>
            <Card
              buttons={[
                <Button
                  key="proceedButton"
                  type="button"
                  disabled={loadingPayment}
                  onClick={() => {
                    handleDeleteAllNotifications();
                    // navigate('/payment'); // DISABLED: navigation is now handled inside handleCreatePayment
                    handleCreatePayment();
                  }}
                >
                  {t("proceedButton")}
                </Button>,
              ]}
              footer
              title={t("subHeader")}
              titleLevel={2}
            >
              <DescriptionList horizontal>
                {(pathname === Pathname.RETAIL ||
                  pathname === Pathname.SME) && (
                  <>
                    <DescriptionList.Group termText={t("details.firstName")}>
                      <DescriptionList.Detail>
                        {OverViewDetails?.firstName}
                      </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("details.lastName")}>
                      <DescriptionList.Detail>
                        {OverViewDetails?.surName}
                      </DescriptionList.Detail>
                    </DescriptionList.Group>
                  </>
                )}
                {pathname === Pathname.FLEET && (
                  <>
                    <DescriptionList.Group
                      termText={t("details.customerNumber")}
                    >
                      <DescriptionList.Detail>
                        {OverViewDetails?.customerNumber}
                      </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("details.companyName")}>
                      <DescriptionList.Detail>
                        {OverViewDetails?.companyName}
                      </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("details.siren")}>
                      <DescriptionList.Detail>
                        {OverViewDetails?.siren}
                      </DescriptionList.Detail>
                    </DescriptionList.Group>
                  </>
                )}
                <DescriptionList.Group termText={t("details.contract")}>
                  <DescriptionList.Detail>
                    {OverViewDetails?.contractNumber}
                  </DescriptionList.Detail>
                </DescriptionList.Group>
                <DescriptionList.Group termText={<>{t("details.payment")}</>}>
                  <DescriptionList.Detail>
                    {OverViewDetails?.outstandingBalance?.toFixed(2)} €
                  </DescriptionList.Detail>
                </DescriptionList.Group>
              </DescriptionList>
            </Card>
          </>
        )}
      </Layout.Item>
      {loadingPayment && <Spinner fullPage>{t("loadingPayment")}</Spinner>}
    </Layout>
  );
};
